"use strict";
exports.__esModule = true;
exports.Gelato = void 0;
var tslib_1 = require("tslib");
var providers_1 = require("@ethersproject/providers");
var utils_1 = require("../common/utils");
var relay_sdk_1 = require("@gelatonetwork/relay-sdk");
var config_1 = require("../common/config");
var Gelato = /** @class */ (function () {
    function Gelato() {
    }
    Gelato.sendTx = function (chainID, contractAddress, sender, data, pkOrProvider) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var walletOrProvider, request, relay, relayResponse, taskID, hash;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof pkOrProvider === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainID)];
                    case 1:
                        walletOrProvider = (_a.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        walletOrProvider = new providers_1.Web3Provider(pkOrProvider);
                        _a.label = 3;
                    case 3:
                        request = {
                            chainId: chainID,
                            target: contractAddress,
                            data: data,
                            user: sender
                        };
                        relay = new relay_sdk_1.GelatoRelay();
                        return [4 /*yield*/, relay.sponsoredCallERC2771(request, walletOrProvider, config_1.Config.GELATO_API_KEY)];
                    case 4:
                        relayResponse = _a.sent();
                        taskID = relayResponse.taskId;
                        return [4 /*yield*/, (0, utils_1.withInterval)(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var response, task, badStates;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, utils_1.fetchGet)("https://relay.gelato.digital/tasks/status/".concat(taskID))];
                                        case 1:
                                            response = _a.sent();
                                            task = response.task;
                                            badStates = ["Cancelled", "ExecReverted"];
                                            if ((task === null || task === void 0 ? void 0 : task.taskState) === "CheckPending" || response.message === "Status not found")
                                                return [2 /*return*/, null];
                                            else if (badStates.includes(task.taskState)) {
                                                return [2 /*return*/, new Error("Gasless transaction Failed")];
                                            }
                                            else {
                                                return [2 /*return*/, task.transactionHash];
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 5:
                        hash = _a.sent();
                        return [2 /*return*/, hash];
                }
            });
        });
    };
    return Gelato;
}());
exports.Gelato = Gelato;
